<template>
	<!-- 盒子管理-盒子管理 -->
	<div class="category">
		<el-row :gutter="10">
			<el-col :span="2">
				<el-button size="small" type="primary" @click="handleAdd">添加盒子
				</el-button>
			</el-col>
			<el-col :span="2">
				<el-input v-model="query.id" placeholder="请输入ID"></el-input>
			</el-col>
			<el-col :span="2">
				<el-input v-model="query.name" placeholder="请输入盒子名称"></el-input>
			</el-col>
			<el-col :span="2">
				<el-input v-model="query.prize_name" placeholder="请输入奖品名称"></el-input>
			</el-col>
			<el-col :span="2">
				<el-select v-model="query.category_id" placeholder="请选择盒子分类" @change="handleSearch">
					<el-option :value="undefined">全部</el-option>
					<el-option v-for="item in categories" :key="item.id" :label="item.name" :value="item.id"></el-option>
				</el-select>
			</el-col>
			<el-col :span="3">
				<el-select v-model="query.box_group_id" placeholder="请选择盒子分组">
					<el-option :value="undefined" label="请选择盒子分组">全部</el-option>
					<el-option v-for="item in boxGroupList" :key="item.id" :label="item.name" :value="item.id"></el-option>
				</el-select>
			</el-col>
			<el-col :span="2" class="right">
				<el-select v-model="query.status" placeholder="盒子状态">
					<el-option :value="undefined" label="请选择状态">全部</el-option>
					<el-option :value="1" label="正常"></el-option>
					<el-option :value="2" label="关闭"></el-option>
					<el-option :value="3" label="补货中"></el-option>
					<el-option :value="4" label="已下架"></el-option>
				</el-select>
			</el-col>
			<el-col :span="1">
				<el-button class="pull-right" type="primary" @click="handleSearch">搜索</el-button>
			</el-col>
			<el-col :span="2" class="right">
				<el-select v-model="query.range" placeholder="概率状态" @change="handleSearch">
					<el-option :value="undefined" label="全部">全部</el-option>
					<el-option :value="1" label="概率异常"></el-option>
				</el-select>
			</el-col>
			<el-col :span="2">
				<el-button class="pull-right" type="primary" @click="refreshProbability">刷新盒子概率</el-button>
			</el-col>
			<el-col :span="1.5">
				<el-button class="pull-right" type="primary" @click="handleSort">盒子排序</el-button>
			</el-col>
			<el-col :span="2">
				<el-button class="pull-right" type="primary" @click="exportVisible = true">导出</el-button>
			</el-col>

			<!--			<el-col :span="2" :offset="4">-->
			<!--				<el-select v-model="luckDrawSetting">-->
			<!--					<el-option label="正常概率" :value="2"></el-option>-->
			<!--					<el-option label="低概率" :value="1"></el-option>-->
			<!--					<el-option label="中概率" :value="0"></el-option>-->
			<!--					<el-option label="高概率" :value="3"></el-option>-->
			<!--				</el-select>-->
			<!--			</el-col>-->
			<!--			<el-col :span="2">-->
			<!--				<el-button size="small" type="primary" @click="setSettingConfig">-->
			<!--					保存概率-->
			<!--				</el-button>-->
			<!--			</el-col>-->
		</el-row>
		<el-row :gutter="10">
			<el-col :span="1.5">
				<el-button class="pull-right" type="primary" @click="handleMinRoll">
					一键设置 min_roll
				</el-button>
			</el-col>
			<el-col :span="1.5">
				<el-button class="pull-right" type="primary" @click="handleMinRollx">
					特殊 roll 设置
				</el-button>
			</el-col>
			<el-col :span="1.5">
				<el-button class="pull-right" type="primary" @click="handleMinRollIncome2">
					批量查询 收益
				</el-button>
			</el-col>
			<el-col :span="1.5">
				<el-button class="pull-right" type="primary" @click="handleMinRollPercent">
					一键设置 min_roll_percent
				</el-button>
			</el-col>
		</el-row>
		<div>
			<el-table :data="dataList" v-loading="loading">
				<el-table-column label="盒子ID" width="100px">
					<template slot-scope="{ row }">
						<span @click="handleDetail(row)">{{ row.id }}</span>
					</template>
				</el-table-column>
				<el-table-column label="盒子名称">
					<template slot-scope="{ row }">
						<span @click="handleDetail(row)">{{ row.name }}</span>
					</template>
				</el-table-column>
				<el-table-column label="图片" width="100px">
					<template slot-scope="{ row }">
						<img width="100" class="table-image" :src="row.image" alt />
					</template>
				</el-table-column>
				<el-table-column label="钥匙图片">
					<template slot-scope="{ row }">
						<img v-if="row.key_image" class="table-image" :src="row.key_image" alt />
					</template>
				</el-table-column>
				<el-table-column label="商品">
					<template slot-scope="{ row }">
						<img v-if="row.goods" class="table-image" :src="row.goods.image" alt />
						<span v-if="row.goods">{{ row.goods.name }}</span>
					</template>
				</el-table-column>
				<el-table-column prop="price" label="价格"></el-table-column>
				<el-table-column prop="category_id" label="盒子分类">
					<template slot-scope="{ row }">
						<span>{{ getCategoryName(row.category_id) }}</span>
					</template>
				</el-table-column>
				<el-table-column prop="box_group_id" label="盒子分组">
					<template slot-scope="{ row }">
						<span>{{ getBoxGroupName(row.box_group_id) }}</span>
					</template>
				</el-table-column>
				<el-table-column prop="buy_number" label="购买赠送基数"></el-table-column>
				<el-table-column prop="giving_number" label="购买赠送次数"></el-table-column>
				<el-table-column prop="weight" label="排序权重"></el-table-column>
				<el-table-column prop="status" label="状态">
					<template slot-scope="{ row }">
						<el-tag type="primary" v-if="row.status === 1">正常</el-tag>
						<el-tag type="danger" v-if="row.status === 2">关闭</el-tag>
						<el-tag type="info" v-if="row.status === 3">补货中</el-tag>
					</template>
				</el-table-column>
				<el-table-column prop="probability_type" label="概率类型">
					<template slot-scope="{ row }">
						<el-tag type="info" v-if="row.probability_type === 'default'">默认类型</el-tag>
						<el-tag type="info" v-if="row.probability_type === 'datdrop'">datdrop</el-tag>
						<el-tag type="info" v-if="row.probability_type === 'java'">java</el-tag>
						<el-tag type="info" v-if="row.probability_type === 'tiger'">老虎机</el-tag>
						<el-tag type="info" v-if="row.probability_type === 'bottom'">保底概率</el-tag>
					</template>
				</el-table-column>
				<el-table-column prop="box_probability" label="箱子概率">
					<template slot-scope="{ row }">
						<div>默认 {{row.box_probability}}</div>
						<div v-if="row.gear !== 0">
							<div>A档位 {{row.gear_info_1_pro}}</div>
							<div>B档位 {{row.gear_info_2_pro}}</div>
							<div>C档位 {{row.gear_info_3_pro}}</div>
							<div>D档位 {{row.gear_info_4_pro}}</div>
						</div>
					</template>
				</el-table-column>
				<el-table-column prop="price_min_pro" label="概率预警最低">
				</el-table-column>
				<el-table-column prop="price_max_pro" label="概率预警最高">
				</el-table-column>
				<el-table-column prop="gear" label="概率档位(对战)">
					<template slot-scope="{ row }">
						<span v-if="row.gear === 0">关闭</span>
						<span v-if="row.gear === 1">
							<div>A档位</div>
							<div>{{row.gear_info_1}}</div>
						</span>
						<span v-if="row.gear === 2">
							<div>B档位</div>
							<div>{{row.gear_info_2}}</div>
						</span>
						<span v-if="row.gear === 3">
							<div>C档位</div>
							<div>{{row.gear_info_3}}</div>
						</span>
						<span v-if="row.gear === 4">
							<div>D档位</div>
							<div>{{row.gear_info_4}}</div>
						</span>
					</template>
				</el-table-column>
				<el-table-column prop="min_roll_percent" label="min_roll_percent">
				</el-table-column>
				<el-table-column prop="min_roll" label="min_roll">
				</el-table-column>
				<el-table-column prop="min_roll_plan" label="min_roll_plan">
				</el-table-column>
				<el-table-column label="操作" fixed="right" width="350px">
					<template slot-scope="{ row }">
						<el-row>
							<el-button type="primary" v-if="row.type === 1" @click="showCdkModel(row.id)">CDK</el-button>
							<el-button type="primary" @click="handleDetail(row)">奖品
							</el-button>
							<el-button type="primary" plain @click="handleEdit(row)">编辑
							</el-button>
							<el-button type="danger" @click="handleDelete(row.id)">删除
							</el-button>
							<el-button type="primary" @click="copyBox(row)">复制盒子
							</el-button>
							<el-button type="primary" @click="getIncome(row)">预计收益
							</el-button>
						</el-row>
					</template>
				</el-table-column>
			</el-table>
		</div>
		<el-dialog :visible.sync="visible" :title="isEdit ? '编辑盒子' : '添加盒子'" width="400px">
			<el-form :model="formData" label-width="140px" :rules="rules" ref="form">
				<el-form-item prop="name" label="盒子名称">
					<el-input v-model="formData.name"></el-input>
				</el-form-item>
				<el-form-item prop="image" label="图片">
					<!-- <el-upload
            class="avatar-uploader"
            :action="action"
            :data="{ disk: imgType }"
            :show-file-list="false"
            :on-success="handleUploadSuccess"
            :before-upload="beforeImageUpload"
            :headers="headers"
            accept="image/*"
            name="file"
          >
            <img class="avatar" v-if="formData.image" :src="formData.image" />
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
          <p>推荐尺寸：300 * 200</p> -->
					<ImgUpload v-model="formData.image"></ImgUpload>
				</el-form-item>
				<el-form-item prop="prize_id" label="奖品">
					<div v-if="selectedPrize" class="prize-item">
						<img :src="selectedPrize.image" @click="visiblePrize = true" />
						<p>
							<span>{{ selectedPrize.name }}</span>
						</p>
						<p>
							<span>{{ selectedPrize.second_name }}</span>
						</p>
						<p>
							<!-- <span :style="`color: ${getRankColor(selectedPrize.rank)};`">{{
                getRank(selectedPrize.rank)
              }}</span> -->
							<span class="price">${{ selectedPrize.price }}</span>
						</p>
					</div>
					<div v-else class="add-prize" @click="visiblePrize = true">
						<i class="el-icon-plus"></i>
						<p>选择奖品</p>
					</div>
				</el-form-item>
				<el-form-item prop="key_image" label="钥匙图片">
					<!-- <el-upload
            class="avatar-uploader"
            :action="action"
            :data="{ disk: imgType }"
            :show-file-list="false"
            :on-success="handleKeyImageUploadSuccess"
            :before-upload="beforeImageUpload"
            :headers="headers"
            accept="image/*"
            name="file"
          >
            <img
              class="avatar"
              v-if="formData.key_image"
              :src="formData.key_image"
            />
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
          <p>推荐尺寸：200 * 200</p> -->
					<ImgUpload v-model="formData.key_image"></ImgUpload>
				</el-form-item>
				<el-form-item prop="box_image" label="盒子图片">
					<!-- <el-upload
            class="avatar-uploader"
            :action="action"
            :data="{ disk: imgType }"
            :show-file-list="false"
            :on-success="handleBoxImageUploadSuccess"
            :before-upload="beforeImageUpload"
            :headers="headers"
            accept="image/*"
            name="file"
          >
            <img
              class="avatar"
              v-if="formData.box_image"
              :src="formData.box_image"
            />
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
          <p>推荐尺寸：200 * 200</p> -->
					<ImgUpload v-model="formData.box_image"></ImgUpload>
				</el-form-item>
				<el-form-item prop="case_image" label="开箱图片">
					<!-- <el-upload
            class="avatar-uploader"
            :action="action"
            :data="{ disk: imgType }"
            :show-file-list="false"
            :on-success="handleCaseImageUploadSuccess"
            :before-upload="beforeImageUpload"
            :headers="headers"
            accept="image/*"
            name="file"
          >
            <img
              class="avatar"
              v-if="formData.case_image"
              :src="formData.case_image"
            />
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
          <p>推荐尺寸：200 * 200</p> -->
					<ImgUpload v-model="formData.case_image"></ImgUpload>
				</el-form-item>
				<!-- <el-form-item prop="new_box_image" label="代替开箱图片">
          <el-upload
            class="avatar-uploader"
            :action="action"
            :data="{ disk: imgType }"
            :show-file-list="false"
            :on-success="handleTiCaseImageUploadSuccess"
            :before-upload="beforeImageUpload"
            :headers="headers"
            accept="image/*"
            name="file"
          >
            <img
              class="avatar"
              v-if="formData.new_box_image"
              :src="formData.new_box_image"
            />
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
          <p>推荐尺寸：200 * 200</p>
        </el-form-item>
        <el-form-item prop="new_key_image" label="代替开箱钥匙图片">
          <el-upload
            class="avatar-uploader"
            :action="action"
            :data="{ disk: imgType }"
            :show-file-list="false"
            :on-success="handleTiKeyImageUploadSuccess"
            :before-upload="beforeImageUpload"
            :headers="headers"
            accept="image/*"
            name="file"
          >
            <img
              class="avatar"
              v-if="formData.new_key_image"
              :src="formData.new_key_image"
            />
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
          <p>推荐尺寸：200 * 200</p>
        </el-form-item> -->
				<el-form-item prop="price" label="价格">
					<el-input v-model="formData.price"></el-input>
				</el-form-item>
				<el-form-item prop="" label="概率预警范围">
					<el-input style="width: 80px" v-model="formData.price_min_pro" placeholder="最低值"></el-input>
					-
					<el-input style="width: 80px" v-model="formData.price_max_pro" placeholder="最高值"></el-input>
				</el-form-item>
				<el-form-item prop="category_id" label="盒子分类">
					<el-select v-model="formData.category_id" placeholder="请选择盒子分类">
						<el-option v-for="item in categories" :key="item.id" :label="item.name" :value="item.id"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item prop="box_level_min" v-if="formData.category_id === 2" label="盒子最低等级">
					<el-input v-model="formData.box_level_min" placeholder="盒子最低等级"></el-input>
				</el-form-item>
				<el-form-item prop="box_group_id" label="盒子分组">
					<el-select v-model="formData.box_group_id" placeholder="盒子分组">
						<el-option v-for="item in boxGroupList" :key="item.id" :label="item.name" :value="item.id + ''"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item prop="activity_group" label="活动分组">
					<el-select v-model="formData.activity_group" placeholder="活动分组">
						<el-option label="否" :value="0"></el-option>
						<el-option label="签到盒子" :value="1"></el-option>
						<el-option label="战力盒子" :value="2"></el-option>
						<el-option label="新用户盒子" :value="3"></el-option>
						<el-option label="活动盒子" :value="4"></el-option>
						<el-option label="充值盒子" :value="5"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item prop="activity_sort" v-if="formData.activity_group != 0" label="活动盒子排序">
					<el-input v-model="formData.activity_sort" placeholder="活动盒子排序"></el-input>
				</el-form-item>
				<el-form-item prop="buy_number" label="购买赠送基数">
					<el-input v-model="formData.buy_number" placeholder="默认9999"></el-input>
				</el-form-item>
				<el-form-item prop="giving_number" label="购买赠送次数">
					<el-input v-model="formData.giving_number" placeholder="默认1"></el-input>
				</el-form-item>
				<el-form-item prop="weight" label="排序权重">
					<el-input v-model="formData.weight" placeholder="默认99"></el-input>
				</el-form-item>
				<el-form-item prop="status" label="状态">
					<el-select v-model="formData.status">
						<el-option :value="1" label="开启">开启</el-option>
						<el-option :value="2" label="关闭">关闭</el-option>
						<el-option :value="3" label="补货中">补货中</el-option>
					</el-select>
				</el-form-item>
				<el-form-item prop="probability_type" label="概率类型">
					<el-select v-model="formData.probability_type">
						<el-option value="default" label="默认类型"></el-option>
						<el-option value="datdrop" label="datdrop"></el-option>
						<el-option value="java" label="java"></el-option>
						<el-option value="tiger" label="老虎机"></el-option>
						<el-option value="bottom" label="保底概率"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item prop="type" label="盒子类型">
					<el-select v-model="formData.type">
						<el-option :value="0" label="普通盒子"></el-option>
						<el-option :value="1" label="CDK盒子"></el-option>
						<el-option :value="2" label="限时盒子"></el-option>
						<el-option :value="3" label="充值盒子"></el-option>
						<el-option :value="5" label="流水盒子"></el-option>
					</el-select>
				</el-form-item>
				<!-- <el-form-item
          v-if="formData.type === 6"
          prop="check_sort"
          label="签到排序"
        >
          <el-input
            v-model="formData.check_sort"
            placeholder="请输入排序号"
          ></el-input>
        </el-form-item> -->
				<el-form-item v-if="formData.type === 5" prop="limit_type" label="盒子时间">
					<el-select v-model="formData.limit_type">
						<el-option :value="1" label="每日"></el-option>
						<el-option :value="2" label="每周"></el-option>
						<el-option :value="3" label="每月"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item prop="label_type" label="盒子标签">
					<el-select v-model="formData.label_type">
						<el-option :value="0" label="无"></el-option>
						<el-option :value="1" label="折扣"></el-option>
						<el-option :value="2" label="新品"></el-option>
						<el-option :value="3" label="热门"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item v-if="formData.label_type === 1" prop="label_value" label="折扣数值">
					<el-input v-model="formData.label_value" placeholder="请输入折扣"></el-input>
				</el-form-item>
				<el-form-item v-if="formData.type === 3 || formData.type === 5" prop="recharge_limit" label="金额限制">
					<el-input v-model="formData.recharge_limit" placeholder="请输入限制金额"></el-input>
				</el-form-item>
				<el-form-item prop="open_day" label="时间间隔">
					<el-input-number v-model="formData.open_day" placeholder="填0表示不受限制" :min="0"></el-input-number>
				</el-form-item>
				<el-form-item prop="open_number" label="次数限制">
					<el-input-number v-model="formData.open_number" placeholder="填0表示不受限制" :min="0"></el-input-number>
				</el-form-item>
				<el-form-item prop="user_level" label="用户等级限制(低)">
					<el-input-number v-model="formData.user_level" placeholder="填0表示不受限制" :min="0"></el-input-number>
				</el-form-item>
				<el-form-item prop="user_level_high" label="用户等级限制(高)">
					<el-input-number v-model="formData.user_level_high" placeholder="填0表示不受限制" :min="0"></el-input-number>
				</el-form-item>
				<el-form-item prop="gear" label="概率档位(对战)">
					<el-select v-model="formData.gear" placeholder="概率档位">
						<el-option :value="0" label="关闭">关闭</el-option>
						<el-option :value="1" label="A档位">A档位</el-option>
						<el-option :value="2" label="B档位">B档位</el-option>
						<el-option :value="3" label="C档位">C档位</el-option>
						<el-option :value="4" label="D档位">D档位</el-option>
					</el-select>
				</el-form-item>
				<el-form-item prop="description" label="概率A档位详情 格式 101-300|501-700">
					<el-input v-model="formData.gear_info_1" placeholder="格式 101-300|501-700"></el-input>
				</el-form-item>
				<el-form-item prop="description" label="概率B档位详情 格式 101-300|501-700">
					<el-input v-model="formData.gear_info_2" placeholder="格式 101-300|501-700"></el-input>
				</el-form-item>
				<el-form-item prop="description" label="概率C档位详情 格式 101-300|501-700">
					<el-input v-model="formData.gear_info_3" placeholder="格式 101-300|501-700"></el-input>
				</el-form-item>
				<el-form-item prop="description" label="概率D档位详情 格式 101-300|501-700">
					<el-input v-model="formData.gear_info_4" placeholder="格式 101-300|501-700"></el-input>
				</el-form-item>
				<el-form-item prop="min_roll" label="min_roll">
					<el-select v-model="formData.min_roll" placeholder="min_roll">
						<el-option :value="1" label="1">1</el-option>
						<el-option :value="2" label="2">2</el-option>
						<el-option :value="3" label="3">3</el-option>
						<el-option :value="4" label="4">4</el-option>
						<el-option :value="5" label="5">5</el-option>
						<el-option :value="6" label="6">6</el-option>
						<el-option :value="7" label="7">7</el-option>
					</el-select>
				</el-form-item>
				<el-form-item prop="description" label="min_roll_plan">
					<el-input v-model="formData.min_roll_plan" placeholder="格式 1|100|500|1000|6000|10000|20000"></el-input>
				</el-form-item>

				<el-form-item prop="description" label="描述">
					<el-input type="textarea" v-model="formData.description"></el-input>
				</el-form-item>
			</el-form>
			<span slot="footer" class="dialog-footer">
				<el-button size="small" @click="visible = false">取 消</el-button>
				<el-button size="small" type="primary" @click="submit" :loading="buttonLoading">确 定</el-button>
			</span>
		</el-dialog>
		<el-pagination background :page-size="dataMeta.per_page || 15" :total="dataMeta.total || 0" :current-page="dataMeta.current_page"
			@current-change="handlePageChange" v-if="dataMeta && dataMeta.total > dataMeta.per_page"></el-pagination>
		<el-dialog :visible.sync="visiblePrize" title="奖品列表" :close-on-click-modal="false" width="930px">
			<el-row style="margin-bottom: 20px">
				<el-input style="width: 200px; margin-right: 20px" placeholder="奖品名称搜索" v-model="prizeName"></el-input>
				<el-button type="primary" @click="getPrize">搜索</el-button>
			</el-row>
			<div class="prize-list-wrap" v-loading="loadingPrize">
				<ul class="prize-list">
					<li class="prize-item" v-for="item in prizeList" :key="item.id">
						<i class="el-icon-plus" title="添加" @click="handleAddPrize(item)"></i>
						<img :src="item.image" alt />
						<p>
							<span>{{ item.name }}</span>
						</p>
						<p>
							<span>{{ item.second_name }}</span>
						</p>
						<p>
							<span :style="`color: ${getRankColor(item.rank)};`">{{
                getRank(item.rank)
              }}</span>
							<span class="price">${{ item.price }}</span>
						</p>
						<p style="text-align: center">
							数量：{{ item.number - item.sold_number }}
						</p>
					</li>
				</ul>
			</div>
			<el-pagination background :page-size="prizeListMeta.per_page || 15" :total="prizeListMeta.total || 0" :current-page="prizePage"
				@current-change="handlePrizePageChange" v-if="prizeListMeta && prizeListMeta.total > prizeListMeta.per_page"></el-pagination>
		</el-dialog>
		<el-drawer title="设置抽奖概率" :visible.sync="luckDraw" :with-header="false" size="80%">
			<span>COPY</span>
			<el-select v-model="copyleft">
				<el-option label="正常权重" value="true_probability"></el-option>
				<el-option label="低权重" value="low_probability"></el-option>
				<el-option label="中权重" value="box_weight"></el-option>
				<el-option label="高权重" value="high_probability"></el-option>
				<el-option label="直播权重" value="zb_probability"></el-option>
			</el-select>
			<span>To</span>
			<el-select v-model="copyright" @change="changeCopy">
				<el-option label="正常权重" value="true_probability"></el-option>
				<el-option label="低权重" value="low_probability"></el-option>
				<el-option label="中权重" value="box_weight"></el-option>
				<el-option label="高权重" value="high_probability"></el-option>
				<el-option label="直播权重" value="zb_probability"></el-option>
			</el-select>
			<el-table :data="prizeData" height="95%" v-loading="prizeDataLoading" show-summary id="cdt">
				<el-table-column prop="id" label="ID" sortable></el-table-column>
				<el-table-column prop="prize.name" label="名称" sortable></el-table-column>
				<el-table-column prop="prize.price" label="价格" sortable :sort-method="sortByPrice"></el-table-column>
				<el-table-column label="正常权重" prop="true_probability" sortable>
					<template slot-scope="scope">
						<span @click="showEdit($event)">{{
              scope.row.true_probability
            }}</span>
						<el-input-number @blur="hideEdit($event, scope.row, 3)" v-show="false" v-model="scope.row.true_probability" size="mini"
							:controls="false" :precision="8"></el-input-number>
					</template>

					<!--					<template slot-scope="scope">-->

					<!--						<el-input-number style="width: 80%" type="number" :max="100" :min="0" :precision="4" :controls="false"-->
					<!--														 size="small" v-model="scope.row.true_probability"></el-input-number>-->
					<!--					</template>-->
				</el-table-column>
				<el-table-column label="低权重" prop="low_probability" sortable>
					<template slot-scope="scope">
						<span @click="showEdit($event)">{{
              scope.row.low_probability
            }}</span>
						<el-input-number @blur="hideEdit($event, scope.row, 3)" v-show="false" v-model="scope.row.low_probability" size="mini"
							:controls="false" :precision="8"></el-input-number>
					</template>
					<!--					<template slot-scope="scope">-->
					<!--						<el-input-number style="width: 80%" type="number" :max="100" :min="0" :precision="4" :controls="false"-->
					<!--														 size="small" v-model="scope.row.low_probability"></el-input-number>-->
					<!--					</template>-->
				</el-table-column>
				<el-table-column label="中权重" prop="box_weight" sortable>
					<template slot-scope="scope">
						<span @click="showEdit($event)">{{ scope.row.box_weight }}</span>
						<el-input-number @blur="hideEdit($event, scope.row, 3)" v-show="false" v-model="scope.row.box_weight" size="mini"
							:controls="false" :precision="8"></el-input-number>
					</template>
					<!--					<template slot-scope="scope">-->
					<!--						<el-input-number style="width: 80%" type="number" :max="100" :min="0" :precision="4" :controls="false"-->
					<!--														 size="small" v-model="scope.row.box_weight"></el-input-number>-->
					<!--					</template>-->
				</el-table-column>
				<el-table-column label="高权重" prop="high_probability" sortable>
					<template slot-scope="scope">
						<span @click="showEdit($event)">{{
              scope.row.high_probability
            }}</span>
						<el-input-number @blur="hideEdit($event, scope.row, 3)" v-show="false" v-model="scope.row.high_probability" size="mini"
							:controls="false" :precision="8"></el-input-number>
					</template>
					<!--					<template slot-scope="scope">-->
					<!--						<el-input-number style="width: 80%" type="number" :max="100" :min="0" :precision="4" :controls="false"-->
					<!--														 size="small" v-model="scope.row.high_probability"></el-input-number>-->
					<!--					</template>-->
				</el-table-column>
				<el-table-column label="直播权重" prop="zb_probability" sortable>
					<template slot-scope="scope">
						<span @click="showEdit($event)">{{
              scope.row.zb_probability
            }}</span>
						<el-input-number @blur="hideEdit($event, scope.row, 3)" v-show="false" v-model="scope.row.zb_probability" size="mini"
							:controls="false" :precision="8"></el-input-number>
					</template>
					<!--					<template slot-scope="scope">-->
					<!--						<el-input-number style="width: 80%" type="number" :max="100" :min="0" :precision="4" :controls="false"-->
					<!--														 size="small" v-model="scope.row.high_probability"></el-input-number>-->
					<!--					</template>-->
				</el-table-column>
				<el-table-column>
					<template slot="header">
						<el-button type="primary" icon="el-icon-download" @click="cdt"></el-button>
						<el-button type="primary" icon="el-icon-check"></el-button>
					</template>
					<template slot-scope="scope">
						<el-button type="primary" @click="pushProbability(scope.row)">提交</el-button>
					</template>
				</el-table-column>
			</el-table>
		</el-drawer>
		<el-drawer title="V3-JAVA" :visible.sync="v3Java" size="90%">
			<el-row :gutter="20">
				<el-col :span="3" style="margin-top: 20px">
					<el-tree :data="weightTypeTree" node-key="type" :highlight-current="true" @node-click="getWeight"></el-tree>
				</el-col>
				<el-col :span="8" v-show="weightType !== ''">
					<el-table :data="weight" v-loading="weightLoading" height="600px">
						<el-table-column prop="id" label="#" width="60px"></el-table-column>
						<el-table-column prop="box_id" label="箱子ID" width="120px"></el-table-column>
						<el-table-column label="盈亏金额" width="120px">
							<template slot-scope="scope">
								<span @click="showEdit($event)">{{
                  scope.row.loss_amount
                }}</span>
								<el-input-number @blur="hideEdit($event, scope.row, 1)" v-show="false" v-model="scope.row.loss_amount" size="mini"
									:controls="false" :precision="2"></el-input-number>
							</template>
						</el-table-column>
						<el-table-column prop="loss_amount">
							<template slot="header">
								<el-button type="primary" icon="el-icon-circle-plus-outline" @click="addWeight"></el-button>
							</template>
							<template slot-scope="scope">
								<el-button size="mini" type="danger" icon="el-icon-delete" @click="delWeight(scope)"></el-button>
								<el-button size="mini" type="info" icon="el-icon-right" @click="getWeightPrize(scope.row.id)"></el-button>
							</template>
						</el-table-column>
					</el-table>
				</el-col>
				<el-col :span="12" v-show="weightId !== ''">
					<el-table :data="weightPrize" v-loading="weightPrizeLoading">
						<el-table-column prop="id" label="ID"></el-table-column>
						<el-table-column label="名称">
							<template slot-scope="scope">
								<el-button type="text" @click="prizeShowDialog(scope)">
									{{ scope.row.prize.name }}
								</el-button>
							</template>
						</el-table-column>
						<el-table-column prop="prize.price" label="价格"></el-table-column>
						<el-table-column label="原始权重">
							<template slot-scope="scope">
								{{ scope.row.box_weight.true_probability * 10000 }}
							</template>
						</el-table-column>
						<el-table-column label="当前权重">
							<template slot-scope="scope">
								{{
                  scope.row.box_weight.true_probability * 10000 +
                  scope.row.weight
                }}
							</template>
						</el-table-column>
						<el-table-column prop="weight" label="修改权重">
							<template slot-scope="scope">
								<span @click="showEdit($event)">{{ scope.row.weight }}</span>
								<el-input-number @blur="hideEdit($event, scope.row, 2)" v-show="false" v-model="scope.row.weight" size="mini"
									:controls="false"></el-input-number>
							</template>
						</el-table-column>
						<el-table-column>
							<template slot="header">
								<el-button type="primary" icon="el-icon-circle-plus-outline" @click="addWeightPrize"></el-button>
							</template>
							<template slot-scope="scope">
								<el-button size="mini" type="danger" icon="el-icon-delete" @click="delWeightPrize(scope)"></el-button>
							</template>
						</el-table-column>
					</el-table>
				</el-col>
			</el-row>
		</el-drawer>
		<!-- 选择饰品 -->
		<el-dialog :visible.sync="prizeShow" title="选择饰品" class="abow_dialog" width="65%">
			<el-row :gutter="20">
				<el-col :span="4" v-for="(item, key) in prizes" :key="key" style="margin-top: 10px; text-align: center; height: 180px">
					<el-card shadow="hover">
						<el-image :src="item.prize.image" fit="scale-down" style="width: 100%; height: 80px" @click="
                choicePrize(
                  item.prize.name,
                  item.prize_id,
                  item.prize.price,
                  item
                )
              "></el-image>
						<span>{{ item.prize.name }}</span><br />
						<span>{{ item.prize.price }}</span>
					</el-card>
				</el-col>
			</el-row>
		</el-dialog>
		<!-- 生成cdk -->
		<el-dialog :visible.sync="cdkModel" title="生成CDK" width="80%">
			<el-row>
				<el-col :span="10">
					<el-table :data="cdkData.data" height="400">
						<el-table-column prop="id" label="#" width="50"></el-table-column>
						<el-table-column prop="name" label="名称" width="120">
							<template slot="header" slot-scope="scope">
								<el-input type="text" v-model="boxCdkSearch.name" placeholder="测试输入名称Enter搜索" size="mini"
									@change="getBoxCdk(boxRowId)"></el-input>
							</template>
						</el-table-column>
						<el-table-column prop="status" label="状态" width="120">
							<template slot="header" slot-scope="scope">
								<el-select v-model="boxCdkSearch.status" placeholder="请选择状态" size="mini" @change="getBoxCdk(boxRowId)">
									<el-option :value="null" label="全部">全部</el-option>
									<el-option :value="0" label="禁用">禁用</el-option>
									<el-option :value="1" label="正常">正常</el-option>
								</el-select>
							</template>
							<template slot-scope="{ row }">
								<el-tag type="success" v-if="row.status === 1">正常</el-tag>
								<el-tag type="info" v-if="row.status === 0">禁用</el-tag>
							</template>
						</el-table-column>
						<el-table-column prop="created_at" label="创建时间">
						</el-table-column>
						<el-table-column label="操作">
							<template slot="header" slot-scope="scope">
								<el-button type="primary" icon="el-icon-plus" circle @click="showCdkAddModel()"></el-button>
							</template>
							<template slot-scope="{ row }">
								<el-button type="primary" v-if="row.status === 1" @click="disableBoxCdk(row)">禁用</el-button>
								<el-button type="primary" v-if="row.status === 0" @click="disableBoxCdk(row)">启用</el-button>
								<el-button type="primary" @click="boxCdkInfo(row.id)">详情</el-button>
							</template>
						</el-table-column>
					</el-table>
					<el-pagination layout="prev, pager, next" :hide-on-single-page="true" :current-page="cdkData.current_page"
						@current-change="changeBoxCdkItemPage" :page-size="cdkData.per_page" :total="cdkData.total">
					</el-pagination>
				</el-col>
				<el-col :span="14">
					<el-table :data="cdkListData.data" height="400">
						<el-table-column prop="id" label="#"></el-table-column>
						<el-table-column prop="cdk_val" label="CDK值">
							<template slot="header" slot-scope="scope">
								<el-input type="text" v-model="boxCdkInfoSearch.cdk_val" placeholder="键入CDK值Enter搜索" size="mini"
									@change="getBoxInfoCdk"></el-input>
							</template>
						</el-table-column>
						<el-table-column prop="status" label="状态">
							<template slot="header" slot-scope="scope">
								<el-select v-model="boxCdkInfoSearch.status" placeholder="请选择状态" size="mini" @change="getBoxInfoCdk">
									<el-option :value="null" label="全部">全部</el-option>
									<el-option :value="-1" label="禁用">禁用</el-option>
									<el-option :value="1" label="正常">正常</el-option>
									<el-option :value="0" label="已使用">已使用</el-option>
								</el-select>
							</template>
							<template slot-scope="{ row }">
								<el-tag type="success" v-if="row.status === 1">正常</el-tag>
								<el-tag type="info" v-if="row.status === 0">已使用</el-tag>
								<el-tag type="info" v-if="row.status === -1">禁用</el-tag>
							</template>
						</el-table-column>
						<el-table-column prop="user_id" label="使用人"></el-table-column>
						<el-table-column label="操作">
							<template slot="header">
								<el-button type="text" icon="el-icon-download" @click="cdkDownload()"></el-button>
							</template>
							<template slot-scope="{ row }">
								<el-button type="primary" v-if="row.status === 1" @click="boxCdkDisable(row)">禁用</el-button>
								<el-button type="primary" v-if="row.status === -1" @click="boxCdkDisable(row)">启用</el-button>
							</template>
						</el-table-column>
					</el-table>
					<el-pagination layout="prev, pager, next" :hide-on-single-page="true" :page-size="cdkListData.per_page"
						:current-page="cdkListData.current_page" :total="cdkListData.total" @current-change="changeBoxCdkPage">
					</el-pagination>
				</el-col>
			</el-row>
		</el-dialog>
		<!-- 添加cdk -->
		<el-dialog :visible.sync="addCdkShow" title="添加CDK" width="40%">
			<el-form label-width="80px">
				<el-form-item label="箱子ID">
					<el-input v-model="addCdkFormData.box_id" disabled></el-input>
				</el-form-item>
				<el-form-item label="名称">
					<el-input v-model="addCdkFormData.name" placeholder="请输入名称"></el-input>
				</el-form-item>
				<el-form-item label="数量">
					<el-input-number v-model="addCdkFormData.number" placeholder="请输入数量" controls-position="right"></el-input-number>
				</el-form-item>
				<el-form-item label="用户id">
					<el-input v-model="addCdkFormData.user_id" placeholder="请输入用户id"></el-input>
				</el-form-item>
				<el-form-item label="名称">
					<el-select v-model="addCdkFormData.status" placeholder="请选择状态">
						<el-option selected :value="1" label="正常">正常</el-option>
						<el-option :value="0" label="禁用">禁用</el-option>
					</el-select>
				</el-form-item>
				<el-form-item>
					<el-button style="float: right" type="primary" @click="pushCdkData">提交</el-button>
				</el-form-item>
			</el-form>
		</el-dialog>
		<!-- 导出箱子信息 -->
		<ExportBoxDataDialog :visible.sync="exportVisible" @close="exportVisible = false"></ExportBoxDataDialog>
		<!-- 一键设置 min_roll -->
		<el-dialog :visible.sync="visibleMinRoll" title="一键设置 min_roll" width="400px">
			<el-form :model="formDataMinRoll" label-width="140px" ref="form">
				<el-form-item prop="activity_group" label="对战箱子min_roll">
					<el-select v-model="formDataMinRoll.box_min_roll" placeholder="对战箱子min_roll">
						<el-option label="不设置" :value="-1"></el-option>
						<el-option label="1" :value="1"></el-option>
						<el-option label="2" :value="2"></el-option>
						<el-option label="3" :value="3"></el-option>
						<el-option label="4" :value="4"></el-option>
						<el-option label="5" :value="5"></el-option>
						<el-option label="6" :value="6"></el-option>
						<el-option label="7" :value="7"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item prop="activity_group" label="用户min_roll">
					<el-select v-model="formDataMinRoll.user_min_roll" placeholder="用户min_roll">
						<el-option label="不设置" :value="-1"></el-option>
						<el-option label="1" :value="1"></el-option>
						<el-option label="2" :value="2"></el-option>
						<el-option label="3" :value="3"></el-option>
						<el-option label="4" :value="4"></el-option>
						<el-option label="5" :value="5"></el-option>
						<el-option label="6" :value="6"></el-option>
						<el-option label="7" :value="7"></el-option>
					</el-select>
				</el-form-item>
			</el-form>
			<span slot="footer" class="dialog-footer">
				<el-button size="small" @click="visibleMinRoll = false">取 消</el-button>
				<el-button size="small" type="primary" @click="submitMinRoll" :loading="buttonLoading">确 定</el-button>
			</span>
		</el-dialog>
		<!-- 设置特殊箱子 min_roll -->
		<el-dialog :visible.sync="visibleMinRollx" title="设置特殊箱子 min_roll" width="600px">
			<el-form label-width="140px" ref="form">
				<el-form-item prop="min_roll_x_enable" label="开关">
					<el-select v-model="formDataMinRollx.min_roll_x_enable" placeholder="开关">
						<el-option label="关闭" :value="0"></el-option>
						<el-option label="开启" :value="1"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item prop="min_roll_x_box_ids" label="箱子ID">
					<el-input v-model="formDataMinRollx.min_roll_x_box_ids" placeholder="请输入箱子ID | 分割"></el-input>
				</el-form-item>
				<el-form-item prop="min_roll_x_num" label="次数设置">
					<el-input v-model="formDataMinRollx.min_roll_x_num" placeholder="(此roll次数|正常次数)"></el-input>
				</el-form-item>
			</el-form>
			<span slot="footer" class="dialog-footer">
				<el-button size="small" @click="visibleMinRollx = false">取 消</el-button>
				<el-button size="small" type="primary" @click="submitMinRollx" :loading="buttonLoading">确 定</el-button>
				<el-button size="small" type="warning" @click="resetMinRollx" :loading="buttonLoading">重 置</el-button>
			</span>
		</el-dialog>
		</span>
		</el-dialog>
		<!-- 预计收益 -->
		<el-dialog :visible.sync="visibleMinRollIncome" title="预计收益" width="400px">
			<el-form :model="formDataMinRoll" label-width="140px" ref="form">
				<div v-for="item in minRollIncomeData">
					<div>min_roll：{{item.min_roll}} | expected_value：{{item.expected_value}} | return_rate：{{item.return_rate}}</div>
				</div>
			</el-form>
			<span slot="footer" class="dialog-footer">
				<el-button size="small" @click="visibleMinRollIncome = false">取 消</el-button>
				<el-button size="small" type="primary" @click="getIncome2()" :loading="buttonLoading">刷新缓存</el-button>
			</span>
		</el-dialog>
		<!-- 批量查询预计收益 -->
		<el-dialog :visible.sync="visibleMinRollIncome2" title="批量查询预计收益" width="400px">
			<el-form :model="formDataMinRollIncome2" label-width="140px" ref="form">
				<el-form-item prop="activity_group" label="箱子id 英文逗号分隔">
					<el-input v-model="formDataMinRollIncome2.ids" placeholder="箱子id"></el-input>
				</el-form-item>
				<el-form-item prop="activity_group" label="min_roll | 分割">
					<el-input v-model="formDataMinRollIncome2.min_roll" placeholder="min_roll"></el-input>
				</el-form-item>
			</el-form>
			<span slot="footer" class="dialog-footer">
				<el-button size="small" @click="visibleMinRollIncome2 = false">取 消</el-button>
				<el-button size="small" type="primary" @click="submitMinRollIncome2" :loading="buttonLoading">确 定</el-button>
			</span>
		</el-dialog>
		<!-- 一键设置 min_roll_percent -->
		<el-dialog :visible.sync="visibleMinRollPercent" title="一键设置 min_roll_percent" width="600px">
			<el-form label-width="140px" ref="form">
				<el-form-item prop="min_roll_percent" label="min_roll_percent">
					<el-input v-model="formDataMinRollPercent.min_roll_percent" placeholder="min_roll_percent"></el-input>
				</el-form-item>
			</el-form>
			<span slot="footer" class="dialog-footer">
				<el-button size="small" @click="visibleMinRollPercent = false">取 消</el-button>
				<el-button size="small" type="primary" @click="submitMinRollPercent" :loading="buttonLoading">确 定</el-button>
			</span>
		</el-dialog>
	</div>
</template>

<script>
	import { mapState, mapActions, mapGetters } from 'vuex'
	import { server, postData, delData, patchData, getData, getApiData, postApiData, patchApiData, api } from '../../http'
	import { getCookie } from '../../utils/cookie'
	import FileSaver from "file-saver";
	import XLSX from "xlsx";
	import ExportBoxDataDialog from "@/components/box/ExportBoxDataDialog.vue";
	import ImgUpload from '@/components/common/ImgUpload.vue'
	import ranks from '@/utils/ranks'
	export default {
		components: {
			ExportBoxDataDialog,
			ImgUpload
		},
		data() {
			this.ranks = ranks
			return {
				exportVisible: false, //导出弹窗显示标志
				imgType: 'box', //上传图片的种类 盒子
				cdkData: [],
				cdkListData: [],
				cdkModel: false,
				copyleft: 'true_probability',
				copyright: 'true_probability',
				weightId: '',
				weightType: '',
				prizes: [],
				prizeShow: false,
				weightTypeTree: [{
						type: 1,
						label: '用户权重配置'
					},
					{
						type: 2,
						label: '网站权重配置'
					}
				],
				weight: [],
				weightPrize: [],
				v3Java: false,
				luckDraw: false,
				luckDrawSetting: 0,
				prizeData: [],
				prizeDataLoading: false,
				formData: {
					name: '',
					image: '',
					key_image: '',
					box_image: '',
					case_image: '',
					new_box_image: '',
					new_key_image: '',
					price: undefined,
					box_group_id: '',
					activity_group: 0, //活动分组 0不是活动分组
					activity_sort: 0, //活动盒子排序\
					price_min_pro: 0,
					price_max_pro: 0,
					category_id: '',
					box_level_min: 0, //盒子最低等级
					goods_id: '',
					buy_number: undefined,
					giving_number: undefined,
					weight: undefined,
					status: 1,
					description: '',
					probability_type: 'default',
					type: 0,
					// check_sort:'',
					label_type: 0,
					limit_type: 1,
					label_value: '',
					recharge_limit: 0,
					open_day: 0,
					open_number: 0,
					user_level_high: 0,
					user_level: 0,
					gear: '',
					gear_info_1: '',
					gear_info_2: '',
					gear_info_3: '',
					gear_info_4: '',
					min_roll: '1',
					min_roll_plan: '1|100|500|1000|6000|10000|20000',
				},
				formDataMinRoll: {
					box_min_roll: -1,
					user_min_roll: -1,
				},
				formDataMinRollx: {
					min_roll_x_enable: -1,
					min_roll_x_box_ids: '',
					min_roll_x_num: '',
				},
				rules: {
					name: [{ required: true, message: '请输入盒子名称' }],
					// image: [{ required: true, message: '请添加盒子图片' }],
					// key_image: [{ required: false, message: '请添加钥匙图片' }],
					// box_image: [{ required: true, message: '请添加盒子图片' }],
					// case_image: [{ required: false, message: '请添加开箱图片' }],
					price: [{ required: true, message: '请输入盒子的价格' }],
					category_id: [{ required: true, message: '请选择盒子所属的分类' }],
					box_level_min: [{ required: true, message: '请输入盒子最低等级' }],
					box_group_id: [{ required: true, message: '请选择盒子所属的分组' }],
				},
				query: {
					page: 1,
					category_id: 1,
					box_group_id: undefined,
					status: undefined,
					id: undefined,
					name: undefined,
					prize_name: undefined,
					range: undefined
				},
				editInfo: undefined,
				loading: false,
				visible: false,
				visibleMinRoll: false,
				visibleMinRollx: false,
				buttonLoading: false,
				isEdit: false,
				loadingPrize: false,
				prizeList: undefined,
				prizeListMeta: {},
				prizePage: 1,
				prizeName: '',
				visiblePrize: false,
				selectedPrize: undefined,
				boxRow: '',
				weightPrizeIndex: '',
				weightLoading: false,
				weightPrizeLoading: false,
				prizeEditRow: '',
				boxCdkSearch: {
					status: '',
					name: '',
					page: 1
				},
				boxDisableData: {
					status: 0
				},
				boxRowId: 0,
				boxCdkInfoSearch: {
					status: '',
					cdk_val: '',
					page: 1
				},
				cdkRow: '',
				addCdkShow: false,
				addCdkFormData: {
					name: '',
					box_id: 0,
					number: '',
					status: '',
					user_id: 0
				},
				visibleMinRollIncome: false,
				minRollIncomeData: [],
				incomeId: '',
				visibleMinRollIncome2: false,
				formDataMinRollIncome2: {
					ids: '',
					min_roll: '',
				},
				visibleMinRollPercent: false,
				formDataMinRollPercent: {
					min_roll_percent: '',
				},
			}
		},
		computed: {
			...mapState({
				dataList: state => state.data.caseList.data,
				dataMeta: state => state.data.caseList.meta,
				categories: state => state.data.categories
			}),
			...mapGetters(['boxGroupList']),
			headers() {
				return {
					Authorization: 'Bearer ' + getCookie('access_token')
				}
			},
			action() {
				return `${server}file`
			}
		},
		watch: {
			visible(val) {
				if (this.editInfo) {
					const {
						name,
						image,
						key_image,
						box_image,
						case_image,
						new_box_image,
						new_key_image,
						price,
						box_group_id,
						activity_group,
						activity_sort,
						price_min_pro,
						price_max_pro,
						category_id,
						box_level_min,
						buy_number,
						giving_number,
						weight,
						status,
						description,
						open_number,
						open_day,
						user_level_high,
						user_level,
						type,
						// check_sort,
						limit_type,
						label_type,
						label_value,
						recharge_limit,
						probability_type,
						gear,
						gear_info_1,
						gear_info_2,
						gear_info_3,
						gear_info_4,
						min_roll,
						min_roll_plan
					} = this.editInfo
					this.formData = {
						name,
						image,
						key_image,
						box_image,
						case_image,
						new_box_image,
						new_key_image,
						price,
						box_group_id,
						activity_group,
						activity_sort,
						price_min_pro,
						price_max_pro,
						category_id,
						box_level_min,
						buy_number,
						giving_number,
						weight,
						status,
						description,
						open_number,
						open_day,
						user_level_high,
						user_level,
						type,
						// check_sort,
						limit_type,
						label_type,
						label_value,
						recharge_limit,
						probability_type,
						gear,
						gear_info_1,
						gear_info_2,
						gear_info_3,
						gear_info_4,
						min_roll,
						min_roll_plan
					}
				} else {
					if (this.$refs['form']) {
						this.$refs['form'].resetFields()
					}
				}
			}
		},
		created() {
			this.getData();
			this.getPrize();
			!this.categories && this.getCategories();
			this.getBoxGroupList();
			this.getSettingConfig();
			this.getMinRollx();
		},
		methods: {
			...mapActions(['getCaseList', 'getCategories', 'getBoxGroupList']),
			changeBoxCdkItemPage(page) {
				this.boxCdkSearch.page = page
				this.getBoxCdk(this.boxRowId)
			},
			changeBoxCdkPage(page) {
				this.boxCdkInfoSearch.page = page
				// getApiData('boxCdkList/' + this.cdkRow, this.boxCdkInfoSearch).then(res => {
				getData('boxCdkList/' + this.cdkRow, this.boxCdkInfoSearch).then(res => {
					this.cdkListData = res
				})
			},
			pushCdkData() {
				// postApiData('boxCdk', this.addCdkFormData).then(res => {
				postData('boxCdk', this.addCdkFormData).then(res => {
					if (res.code) {
						this.$message.success(res.msg)
						this.getBoxCdk(this.boxRowId)
						this.addCdkShow = false
					} else {
						this.$message.error(res.msg)
					}
				})
			},
			showCdkAddModel() {
				this.addCdkShow = true
				this.addCdkFormData.box_id = this.boxRowId
			},
			showCdkModel(rowId) {
				this.cdkModel = true
				this.boxRowId = rowId
				this.getBoxCdk(rowId)
			},
			getBoxInfoCdk() {
				// getApiData('boxCdkList/' + this.cdkRow, this.boxCdkInfoSearch).then(res => {
				getData('boxCdkList/' + this.cdkRow, this.boxCdkInfoSearch).then(res => {
					this.cdkListData = res
				})
			},
			cdkDownload() {
				window.location.href = api + 'cdkDownload/' + this.cdkRow
			},
			getBoxCdk(rowId) {
				// getApiData('boxCdk/' + rowId, this.boxCdkSearch).then(res => {
				getData('boxCdk/' + rowId, this.boxCdkSearch).then(res => {
					this.cdkData = res
				})
			},
			disableBoxCdk(row) {
				if (row.status === 1) {
					this.boxDisableData.status = 0
				} else {
					this.boxDisableData.status = 1
				}
				// patchApiData('boxCdkStatus/' + row.id, this.boxDisableData).then(res => {
				patchData('boxCdkStatus/' + row.id, this.boxDisableData).then(res => {
					this.$message.success("SUCCESS")
					this.getBoxCdk(this.boxRowId)
				})
			},
			boxCdkInfo(rowId) {
				this.cdkRow = rowId
				// getApiData('boxCdkList/' + rowId, this.boxCdkInfoSearch).then(res => {
				getData('boxCdkList/' + rowId, this.boxCdkInfoSearch).then(res => {
					this.cdkListData = res
				})
			},
			boxCdkDisable(row) {
				if (row.status === 1) {
					this.boxDisableData.status = -1
				} else {
					this.boxDisableData.status = 1
				}
				// patchApiData('cdkListStatus/' + row.id, this.boxDisableData).then(res => {
				patchData('cdkListStatus/' + row.id, this.boxDisableData).then(res => {
					this.$message.success("SUCCESS")
					this.getBoxCdk(this.boxRowId)
					// getApiData('boxCdkList/' + this.cdkRow, this.boxCdkInfoSearch).then(res => {
					getData('boxCdkList/' + this.cdkRow, this.boxCdkInfoSearch).then(res => {
						this.cdkListData = res
					})
				})
			},
			changeCopy() {
				let prizeDataTemp = this.prizeData
				let left = this.copyleft
				let right = this.copyright
				prizeDataTemp.forEach(function(item, index) {
					prizeDataTemp[index][right] = item[left]
				})
				this.prizeData = prizeDataTemp
			},
			cdt() {
				let wb = XLSX.utils.table_to_book(document.querySelector("#cdt"));
				/* 获取二进制字符串作为输出 */
				let wbout = XLSX.write(wb, {
					bookType: "xlsx",
					bookSST: true,
					type: "array"
				});
				try {
					FileSaver.saveAs(
						//Blob 对象表示一个不可变、原始数据的类文件对象。
						//Blob 表示的不一定是JavaScript原生格式的数据。
						//File 接口基于Blob，继承了 blob 的功能并将其扩展使其支持用户系统上的文件。
						//返回一个新创建的 Blob 对象，其内容由参数中给定的数组串联组成。
						new Blob([wbout], { type: "application/octet-stream" }),
						//设置导出文件名称
						"sheetjs.xlsx"
					);
				} catch (e) {
					if (typeof console !== "undefined") console.log(e, wbout);
				}
				return wbout;
			},
			addWeight() {
				if (this.weightType === '') {
					this.$message({
						message: "请选择权重类型",
						type: 'error'
					})
					return false
				}
				this.weight.unshift({ id: '', box_id: this.boxRow, loss_amount: 0.00, type: this.weightType })
			},
			addWeightPrize() {
				this.weightPrize.unshift({
					id: '',
					weight_id: this.weightId,
					weight: 0,
					prize: { name: '请选择饰品', price: '' },
					box_weight: { true_probability: 0 },
					prize_id: ''
				})
			},
			delWeight(scope) {
				if (scope.row.id === '') {
					this.weight.splice(scope.$index, 1)
				} else {
					this.weightLoading = true
					getApiData('delWeight', { id: scope.row.id }).then(res => {
						this.$message({
							message: res.msg,
							type: res.type
						})
						if (res.type === 'success') {
							getApiData('getWeight', { type: this.weightType, box_id: this.boxRow }).then(res => {
								this.weight = res
								this.weightPrize = []
								this.weightLoading = false
							})
						} else {
							this.weightLoading = false
						}
					})
				}
			},
			delWeightPrize(scope) {
				if (scope.row.id === '') {
					this.weightPrize.splice(scope.$index, 1)
				} else {
					this.weightPrizeLoading = true
					getApiData('delPrizeWeight', { id: scope.row.id }).then(res => {
						this.$message({
							message: res.msg,
							type: res.type
						})
						getApiData('getPrizeWeight', { weight_id: this.weightId }).then(res => {
							this.weightPrize = res
						})
						this.weightPrizeLoading = false
					})
				}
			},
			showEdit(event) {
				event.currentTarget.style.display = "none"
				event.currentTarget.nextElementSibling.style.display = "block"
				event.currentTarget.nextElementSibling.children[0].children[0].focus()
			},
			hideEdit(event, row, type) {
				event.currentTarget.parentElement.parentElement.style.display = "none"
				event.currentTarget.parentElement.parentElement.previousElementSibling.style.display = "block"
				if (type === 1) {
					this.weightLoading = true
					postApiData("setWeight", {
						box_id: row.box_id,
						loss_amount: row.loss_amount,
						type: row.type,
						id: row.id
					}).then(res => {
						getApiData('getWeight', { type: row.type, box_id: this.boxRow }).then(res => {
							this.weight = res
							this.weightPrize = []
							this.weightLoading = false
						})
					})
				} else if (type === 2) {
					if (row.prize_id === undefined || row.prize_id === null || row.prize_id === '') {
						this.$message({
							message: "请选择饰品",
							type: 'warning'
						})
						return false
					}
					this.weightPrizeLoading = true
					postApiData('setPrizeWeight', {
						prize_id: row.prize_id,
						weight: row.weight,
						id: row.id,
						weight_id: this.weightId
					}).then(res => {
						getApiData('getPrizeWeight', { weight_id: this.weightId }).then(res => {
							this.weightPrize = res
							this.weightPrizeLoading = false
						})
					})
				} else if (type === 3) {
					postApiData('set_luck_setting_prize', {
						id: row.id,
						box_id: row.box_id,
						box_weight: row.box_weight,
						high_probability: row.high_probability,
						true_probability: row.true_probability,
						low_probability: row.low_probability,
						zb_probability: row.zb_probability
					}).then(res => {
						switch (res.info) {
							case 0:
								this.$message({
									message: '修改成功',
									type: 'success'
								})
								break
							case 3:
								this.$message({
									message: '正常权重概率不足100，无法正常启用',
									type: 'warning'
								})
								break
							case 2:
								this.$message({
									message: '低权重概率不足100，无法正常启用',
									type: 'warning'
								})
								break
							case 1:
								this.$message({
									message: '中权重概率不足100，无法正常启用',
									type: 'warning'
								})
								break
							case 4:
								this.$message({
									message: '高权重概率不足100，无法正常启用',
									type: 'warning'
								})
								break
							case 5:
								this.$message({
									message: '直播概率不足100，无法正常启用',
									type: 'warning'
								})
								break
						}
					})
				}
			},
			choicePrize(name, id, price, item) {
				this.weightPrize[this.weightPrizeIndex].prize.name = name
				this.weightPrize[this.weightPrizeIndex].prize.price = price
				this.weightPrize[this.weightPrizeIndex].prize_id = id
				this.weightPrize[this.weightPrizeIndex].box_weight = item
				this.prizeShow = false
				if (this.prizeEditRow.weight !== 0) {
					this.weightPrizeLoading = true
					postApiData('setPrizeWeight', {
						prize_id: this.prizeEditRow.prize_id,
						weight: this.prizeEditRow.weight,
						id: this.prizeEditRow.id,
						weight_id: this.weightId
					}).then(res => {
						getApiData('getPrizeWeight', { weight_id: this.weightId }).then(res => {
							this.weightPrize = res
							this.weightPrizeLoading = false
						})
					})
				}
			},
			prizeShowDialog(scope) {
				this.prizeShow = true
				this.weightPrizeIndex = scope.$index
				getApiData("get_luck_setting_prize", { boxId: this.boxRow }).then(res => {
					this.prizes = res
					this.prizeEditRow = scope.row
				})
			},
			getWeight(data) {
				this.weightType = data.type
				this.weightLoading = true
				getApiData('getWeight', { type: data.type, box_id: this.boxRow }).then(res => {
					this.weight = res
					this.weightPrize = []
					this.weightLoading = false
				})
			},
			v3JavaShow(row) {
				this.weightType = ''
				this.boxRow = row
				this.weight = []
				this.weightPrize = []
				this.v3Java = true
				this.weightId = ''
			},
			getWeightPrize(id) {
				this.weightPrizeLoading = true
				getApiData('getPrizeWeight', { weight_id: id, box_id: this.boxRow }).then(res => {
					this.weightId = id
					this.weightPrize = res
					this.weightPrizeLoading = false
				})
			},
			sortByPrice(obj1, obj2) {
				let val1 = obj1.prize.price
				let val2 = obj2.prize.price
				return val2 - val1
			},
			getSettingConfig() {
				getApiData("getSettingConfig").then(res => {
					this.luckDrawSetting = res
				})
			},
			setSettingConfig() {
				postApiData("setSettingConfig", { val: this.luckDrawSetting }).then(res => {
					this.$message({
						message: res.msg,
						type: res.type
					})
				})
			},
			pushProbability(row) {
				postApiData('set_luck_setting_prize', {
					id: row.id,
					box_id: row.box_id,
					box_weight: row.box_weight,
					high_probability: row.high_probability,
					true_probability: row.true_probability,
					low_probability: row.low_probability,
					zb_probability: row.zb_probability
				}).then(res => {
					switch (res.info) {
						case 0:
							this.$message({
								message: '修改成功',
								type: 'success'
							})
							break
						case 1:
							this.$message({
								message: '正常权重概率不足100，无法正常启用',
								type: 'warning'
							})
							break
						case 2:
							this.$message({
								message: '低权重概率不足100，无法正常启用',
								type: 'warning'
							})
							break
						case 3:
							this.$message({
								message: '中权重概率不足100，无法正常启用',
								type: 'warning'
							})
							break
						case 4:
							this.$message({
								message: '高权重概率不足100，无法正常启用',
								type: 'warning'
							})
							break
					}
				})
			},
			getBoxPrize(boxId) {
				this.luckDraw = true
				this.prizeDataLoading = true
				getApiData("get_luck_setting_prize", { boxId: boxId }).then(res => {
						this.prizeData = res
						this.prizeDataLoading = false
					})
					.finally(() => {
						this.prizeDataLoading = false
					})
			},
			getRank(rank) {
				return ''
				// for (let item of this.ranks) {
				// 	if (item.level === rank) {
				// 		return item.text
				// 	}
				// }
			},
			getRankColor(rank) {
				return '#000'
				// for (let item of this.ranks) {
				// 	if (item.level === rank) {
				// 		return item.color
				// 	}
				// }
			},
			getCategoryName(id) {
				if (this.categories) {
					for (let item of this.categories) {
						if (item.id == id) {
							return item.name
						}
					}
				} else {
					return ''
				}
			},
			getBoxGroupName(id) {
				if (this.boxGroupList) {
					for (let item of this.boxGroupList) {
						if (item.id == id) {
							return item.name
						}
					}
				} else {
					return ''
				}
			},
			beforeImageUpload(file) {
				if (file.size > 2 * 1024 * 1024) {
					this.$message.error('图片尺寸过大，请选择2M大小以下的图片上传')
					return false
				}
			},
			handleUploadSuccess(res) {
				if (res.path) {
					this.formData.image = res.path
				} else {
					this.$message.error('上传失败')
				}
				this.$refs['form'].validateField('image')
			},
			handleKeyImageUploadSuccess(res) {
				if (res.path) {
					this.formData.key_image = res.path
				} else {
					this.$message.error('上传失败')
				}
				this.$refs['form'].validateField('key_image')
			},
			handleBoxImageUploadSuccess(res) {
				if (res.path) {
					this.formData.box_image = res.path
				} else {
					this.$message.error('上传失败')
				}
				this.$refs['form'].validateField('box_image')
			},
			handleCaseImageUploadSuccess(res) {
				if (res.path) {
					this.formData.case_image = res.path
				} else {
					this.$message.error('上传失败')
				}
				this.$refs['form'].validateField('case_image')
			},
			handleTiCaseImageUploadSuccess(res) {
				if (res.path) {
					this.formData.new_box_image = res.path
				} else {
					this.$message.error('上传失败')
				}
				this.$refs['form'].validateField('new_box_image')
			},
			handleTiKeyImageUploadSuccess(res) {
				if (res.path) {
					this.formData.new_key_image = res.path
				} else {
					this.$message.error('上传失败')
				}
				this.$refs['form'].validateField('new_key_image')
			},
			getData() {
				this.loading = true
				this.getCaseList({
					...this.query
				}).finally(() => {
					this.loading = false
				})
			},
			handleSearch() {
				this.query.page = 1
				this.getData()
			},
			refreshProbability() {
				//刷新盒子概率
				this.loading = true
				getData(`all_box`)
					.then(res => {
						if (res) {
							this.getData()
						}
					})
					.finally(() => {
						this.loading = false
					})
			},
			handleSort() {
				//排序
				let params = {
					category_id: this.query.category_id,
					box_group_id: this.query.box_group_id,
					status: this.query.status
				}
				postApiData('box_weight', params).then(res => {
					this.$message.success('已排序')
					this.getData()
				})
			},
			handleAdd() {
				this.isEdit = false
				this.editInfo = undefined
				this.visible = true
			},
			handleEdit(row) {
				this.isEdit = true
				this.editInfo = row
				this.selectedPrize = row.goods
				this.visible = true
			},
			handleDetail(row) {
				// this.$router.push(`/case/${row.id}?cid=${row.category_id}`)
				// let routeData = this.$router.resolve({ path: `/case/${row.id}?now_box_id=${row.id}&cid=${row.category_id}` })
				let params = {
					now_box_id: row.id,
					cid: row.category_id,
					now_box_type: row.category_id
				}
				let routeData = this.$router.resolve({ path: `/case/${row.id}`, query: params })
				window.open(routeData.href, '_blank')
			},
			handlePageChange(page) {
				this.query.page = page
				this.getData()
			},
			handleDelete(id) {
				this.$prompt('请输入密码', '确定要删除吗？', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					inputPattern: /lijiulong123/,
					inputErrorMessage: '密码不正确'
				}).then(({ value }) => {
					delData(`box/${id}`).then(res => {
						this.$message.success('删除成功')
						this.getData()
					})
				}).catch(() => {
					this.$message({
						type: 'info',
						message: '取消删除'
					})
				})
				// this.$confirm('确定要删除吗？', {
				//   type: 'warning'
				// }).then(res => {
				//   delData(`box/${id}`).then(res => {
				//     this.$message.success('删除成功')
				//     this.getData()
				//   })
				// })
			},
			copyBox(rowInfo) {
				//复制盒子
				this.$confirm(`确定要复制 <${rowInfo.name}> 盒子吗？`, {
					type: 'warning'
				}).then(res => {
					patchApiData(`box_copy/${rowInfo.id}`).then(res => {
						this.$message.success("复制成功！")
						this.getData() //刷新成功
					}).finally(() => {})
				})
			},
			submit() {
				this.$refs['form'].validate(valid => {
					if (valid) {
						if (parseInt(this.formData.category_id) === 2 && parseInt(this.formData.weight) <= 1 && this.formData.name !=
							'M9注册福利宝箱') {
							//保证等级箱子新人注册箱始终排在第一位
							this.$message.error('等级箱子的排序权重必须大于1')
							return
						}
						//判断用户等级箱子等级限制高低
						let judgeInfo = this.checkoutLevel(this.formData);
						if (!judgeInfo.flag) {
							this.$message.error(judgeInfo.text)
							return
						}
						this.buttonLoading = true
						if (!this.editInfo) {
							postData('box', {
									...this.formData,
									buy_number: this.formData.buy_number || 9999
								})
								.then(res => {
									this.buttonLoading = false
									this.visible = false
									this.$message.success('添加成功')
									this.getData()
								})
								.finally(() => {
									this.buttonLoading = false
								})
						} else {
							const params = { ...this.formData }
							if (!params.buy_number) params.buy_number = 9999
							if (!params.giving_number) params.giving_number = 1
							if (!params.weight) params.weight = 99
							patchData(`box/${this.editInfo.id}`, {
									...params
								})
								.then(res => {
									this.buttonLoading = false
									this.visible = false
									this.$message.success('编辑成功')
									this.getData()
								})
								.finally(() => {
									this.buttonLoading = false
								})
						}
					}
				})
			},
			checkoutLevel(info) {
				// 检查用户等级限制数值设置是否正确
				if (info.user_level_high != 0 && info.user_level > info.user_level_high) {
					//用户高等级限制不为0，同时 低等级限制>=高等级限制，提示输入错误
					return {
						flag: false,
						text: '等级限制(高)不为0时 必须大于或于等级限制(低)'
					}
				} else {
					return {
						flag: true,
						text: ''
					}
				}
			},
			getPrize() {
				this.loadingPrize = true
				getData(`prize`, { category_id: this.query.category_id, page: this.prizePage, name: this.prizeName })
					.then(res => {
						this.prizeList = res.data
						this.prizeListMeta = res.meta
					})
					.finally(() => {
						this.loadingPrize = false
					})
			},
			handlePrizePageChange(page) {
				this.prizePage = page
				this.getPrize()
			},
			handleAddPrize(row) {
				this.formData.goods_id = row.id
				this.selectedPrize = row
				this.visiblePrize = false
			},
			handleRemovePrize() {
				this.formData.goods_id = undefined
				this.selectedPrize = undefined
			},
			handleMinRoll() {
				this.visibleMinRoll = true
			},
			handleMinRollx() {
				this.visibleMinRollx = true
			},
			submitMinRoll() {
				if (this.formDataMinRoll.box_min_roll == -1 && this.formDataMinRoll.user_min_roll == -1) {
					this.$message.error('未设置')
					return
				}
				const params = { ...this.formDataMinRoll }
				postData(`set_min_roll`, {
						...params
					})
					.then(res => {
						this.buttonLoading = false
						this.visibleMinRoll = false
						this.formDataMinRoll.box_min_roll = -1;
						this.formDataMinRoll.user_min_roll = -1;
						this.$message.success('成功')
						this.getData()
					})
					.finally(() => {
						this.buttonLoading = false
					})
			},
			getMinRollx() {
				getData(`get_min_roll_x`).then(res => {
					if (res.code == 200) {
						this.formDataMinRollx = res.data
					} else {
						this.$message.error('失败')
					}
				})
			},
			resetMinRollx() {
				getData(`reset_min_roll_x`).then(res => {
					this.$message.success('成功')
				})
			},
			submitMinRollx() {
				const params = { ...this.formDataMinRollx }
				postData(`set_min_roll_x`, {
						...params
					})
					.then(res => {
						this.buttonLoading = false
						this.visibleMinRollx = false
						this.$message.success('成功')
						this.getData()
					})
					.finally(() => {
						this.buttonLoading = false
					})
			},
			getIncome(row) {
				let id = row.id;
				this.incomeId = id;
				this.minRollIncomeData = [];
				let params = { id: id }
				postData(`get_income`, {
						...params
					})
					.then(res => {
						// console.log(res);
						if (res.code == 200) {
							this.visibleMinRollIncome = true;
							this.minRollIncomeData = res.data;
						} else {
							this.$message.error('失败')
						}
					})
					.finally(() => {
						this.buttonLoading = false
					})
			},
			getIncome2() {
				this.minRollIncomeData = [];
				let params = { id: this.incomeId, n: 1 }
				postData(`get_income`, {
						...params
					})
					.then(res => {
						// console.log(res);
						if (res.code == 200) {
							this.visibleMinRollIncome = true;
							this.minRollIncomeData = res.data;
						} else {
							this.$message.error('失败')
						}
					})
					.finally(() => {
						this.buttonLoading = false
					})
			},
			handleMinRollIncome2() {
				this.visibleMinRollIncome2 = true;
			},
			submitMinRollIncome2() {
				if (!this.formDataMinRollIncome2.ids || !this.formDataMinRollIncome2.min_roll) {
					this.$message.error('请输入')
					return
				}
				const params = { ...this.formDataMinRollIncome2 }
				postData(`get_batch_income`, {
						...params
					})
					.then(res => {
						this.buttonLoading = false
						this.visibleMinRollIncome2 = false
						this.formDataMinRollIncome2.ids = '';
						this.formDataMinRollIncome2.min_roll = '';
						this.$message.success('成功')
						this.getData()
					})
					.finally(() => {
						this.buttonLoading = false
					})
			},
			handleMinRollPercent() {
				this.visibleMinRollPercent = true;
			},
			submitMinRollPercent() {
				if (!this.formDataMinRollPercent.min_roll_percent) {
					this.$message.error('请输入')
					return
				}
				const params = { ...this.formDataMinRollPercent }
				postData(`set_batch_min_roll_percent`, {
						...params
					})
					.then(res => {
						this.buttonLoading = false
						this.visibleMinRollPercent = false
						this.formDataMinRollPercent.min_roll_percent = '';
						this.$message.success('成功')
						this.getData()
					})
					.finally(() => {
						this.buttonLoading = false
					})
			},
		},
	}
</script>

<style lang="less">
	.table-image {
		max-height: 100px;
		max-width: 100px;
	}

	.avatar-uploader {
		.avatar-uploader-icon {
			font-size: 28px;
			color: #8c939d;
			width: 128px;
			height: 128px;
			line-height: 128px;
			text-align: center;
		}

		.el-upload {
			border: 1px dashed #d9d9d9;
			border-radius: 6px;
			cursor: pointer;
			position: relative;
			overflow: hidden;
		}

		.el-upload:hover {
			border-color: #409eff;
		}

		.avatar {
			width: 128px;
			height: 128px;
			display: block;
		}
	}

	/*1.显示滚动条：当内容超出容器的时候，可以拖动：*/
	.el-drawer__body {
		overflow: auto;
		/* overflow-x: auto; */
	}

	/*2.隐藏滚动条，太丑了*/
	.el-drawer__container ::-webkit-scrollbar {
		display: none;
	}

	.abow_dialog {
		display: flex;
		justify-content: center;
		align-items: Center;
		overflow: hidden;

		.el-dialog {
			margin: 0 auto !important;
			height: 90%;
			overflow: hidden;

			.el-dialog__body {
				position: absolute;
				left: 0;
				top: 54px;
				bottom: 0;
				right: 0;
				padding: 0;
				z-index: 1;
				overflow: hidden;
				overflow-y: auto;
			}
		}
	}
</style>